'use strict';

export default class RadioButton {
  constructor() {
    this.name = 'radio-button';

  }
}
